import { TFunction } from 'i18next';
import {
  getTypeOfRequestOptions,
  getHRNSampleStatusOptions,
  getPaperConsentOptions,
} from '../components/WithdrawalForm/WithdrawalForm.helper';
import { DropdownItem } from '@/common/components';

export const createTypeOfRequestOptions = (t: TFunction): DropdownItem[] => getTypeOfRequestOptions(t);

export const createHRNSampleStatusOptions = (t: TFunction): DropdownItem[] => getHRNSampleStatusOptions(t);

export const createPaperConsentOptions = (t: TFunction): DropdownItem[] => getPaperConsentOptions(t);
